export const toContactOption = (contact)=>{
    const name = contact.fullName();
    const companyName = contact.companyName();
    const email = contact.email();
    return {
        id: contact.id(),
        name,
        companyName,
        email,
        label: "".concat(companyName, ", ").concat(name, " (").concat(email, ")")
    };
};
